import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { verificationEmail } from '../../services/apiService';

function VerifyEmail({ show, handleClose, title, email }) {
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState(''); // State to store the error message

  // Clear the verification code and error when the modal is shown
  useEffect(() => {
    if (show) {
      setVerificationCode(''); // Clear the input field when the modal is shown
      setError(''); // Clear any existing error
    }
  }, [show]);

  // Handle input change to update verification code state
  const handleCodeChange = (event) => {
    setVerificationCode(event.target.value);
    setError(''); // Clear the error when the user starts typing
  };

  // Function to handle verify button click
  const handleVerifyClick = async () => {
    try {
      await verificationEmail(email, verificationCode);
      handleClose(true); // Close the modal on successful verification
    } catch (error) {
      const msg = error.message || 'Verification failed. Please try again.';
      if (msg.includes('already in the sign-up queue')) {
        handleClose(true); // Treat already-in-queue as success, show success modal
        return;
      }
      setError(msg);
    }
  };

  return (
    <Modal show={show} onHide={() => handleClose()} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          We have sent a verification code to your email address. Please enter the code below to confirm your email address.
        </p>
        <Form.Group className="mb-3" controlId="verificationCode">
          <Form.Label>Enter Verification Code</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your code here"
            value={verificationCode}
            onChange={handleCodeChange}
            className={error ? 'is-invalid' : ''}
            isInvalid={!!error} // Mark the input as invalid if there's an error
          />
          <Form.Control.Feedback type="invalid">
            {error} {/* Display the error message */}
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="rounded-0" onClick={handleVerifyClick}>
          Verify
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VerifyEmail;
